import { Box, CardContent, Grid, Typography, Drawer, Divider, Button } from '@mui/material';
import { FC, useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import EditIcon from '@mui/icons-material/ModeEdit';
import { SettingsInformation } from "../../utils/account.types";
import CardData from "../CardData/CardData";
import SettingDialogForm from "./SettingDialogForm";
import { fetchAccountById, updateAccount } from "../../store/accountThunk";
import { StyledCard } from '../AccountBasicInfo/AccountBacisInfo.styles';

const Settings: FC = () => {
  const dispatch = useAppDispatch();
  const [accountBasicInf, setaccountBasicInf] = useState<SettingsInformation>();
  const [open, setOpen] = useState(false);

  const accountDetails = useAppSelector(state => state.account.accountDetails);

  const cardClicked = () => {
    handleOpen();
  }

  const getData = (data: any): SettingsInformation => {
    const { subscription, verifiedStatus } = data;
    return {
      'subscription': { value: subscription?.plan, title: 'Plan' },
      'verifiedStatus': { value: verifiedStatus === 'false' ? 'No' : 'Yes', title: 'Verified Status' },
    };
  };

  const getSettingsData = () => {
    const data = [];
    for (const key in accountBasicInf) {
      data.push(<CardData key={key} card={accountBasicInf[key as keyof SettingsInformation]} />)
    }
    return data;
  }

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const onSubmit = async (data: any) => {
    // Dispatch add account action.
    try {
      const responseData: any = await dispatch(updateAccount({
        id: accountDetails._id,
        accountPayload: data,
      }));

      if (responseData && responseData?.status === 200) {
        dispatch(fetchAccountById(accountDetails._id));
        handleClose();
      }
    } catch (error: any) {

      // Empty catch block.
      console.log(error);
    }
  };

  useEffect(() => {
    let settingInfoAvaliable = true;

    const settingsInfo = () => {
      try {

        if (settingInfoAvaliable) {
          Object.keys(accountDetails).length && setaccountBasicInf(getData(accountDetails));
        }
      } catch (error: any) {
        console.log('Setting catch block called')
      }
    };
    settingsInfo();
    return () => {
      settingInfoAvaliable = false;
    };
  }, [accountDetails]);


  return (
    <>
      <div className={'c-card2'} style={{ padding: 15, paddingTop: 10, paddingBottom: 10 }}>
      <Button
        size='small'
        variant="contained"
        style={{
          float: "right",
          color: '#488dff',
          backgroundColor: '#fff',
          border: '0.5px solid #488dff',
          height: 25, borderRadius: 7
        }}
        onClick={cardClicked}
      >Change
      </Button>
      <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15, marginBottom:10 }}>Settings</h5>
        <Divider sx={{ mt: 0.5, mb: 1 }} />
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>{accountBasicInf?.subscription.title}</h5>
            <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 3 }}>{accountBasicInf?.subscription.value}</h5>
          </Grid>
          <Grid item xs={6}>
            <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>{accountBasicInf?.verifiedStatus.title}</h5>
            <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 3 }}>{accountBasicInf?.verifiedStatus.value}</h5>
          </Grid>
        </Grid>
        <Drawer
          anchor="right"
          open={open}
        >
          {<SettingDialogForm title='Update Account' open={open} data={accountDetails} onClose={handleClose} onSubmit={onSubmit} />}
        </Drawer>
      </div>
    </>
  );
};

export default Settings;
